declare const jQuery: any;
const $ = jQuery;
const ajaxCall: Function = window["iw"].utils.ajaxCall;
const getScrollOffsetForHeader: Function = window["iw"].layout.getScrollOffsetForHeader;

export function initCaseStudyCategoryButtons(): void
{
    const $wrap = $("body.case-studies-page .gcf-case-study-category-buttons");
    if ($wrap.length === 0)
    {
        return;
    }
    const $postCardsWrap = $(".gcf-post-cards");
    const $wraps = $wrap.add($postCardsWrap);
    const $btns = $("[data-cat]");
    let $ul = $postCardsWrap.find("ul");
    $btns.on("click", async function (e) {
        e.preventDefault();
        const $btn = $(this);
        if ($btn.hasClass("current"))
        {
            return false;
        }
        const catId: number = parseInt($btn.attr("data-cat"), 10) || 0;
        $wraps.addClass("busy");
        const $newUl = await getUL(catId);
        $wraps.removeClass("busy");
        if (!$newUl)
        {
            return false;
        }
        $newUl.insertAfter($ul);
        $ul.remove();
        $ul = $newUl;
        $ul.removeClass("hidden");
        const $lis = $newUl.children("li");
        $btns.removeClass("current");
        $btn.addClass("current");
        $lis.each(function (index: number) {
            const $li = $(this);
            setTimeout(() => {
                $li.css({ opacity: 1 });
            }, index * 100);
        });
        $.scrollTo($newUl, 400, {
            axis: "y",
            offset: {
                top: getScrollOffsetForHeader()
            }
        });
        return false;
    });
}

async function getUL(catId: number): Promise<any>
{
    const result = await ajaxCall("get_case_studies", { cat: catId });
    if (!result.hasOwnProperty("html"))
    {
        console.log(`Bad result from server`, result);
        return undefined;
    }
    const html: string = result.html;
    const $wrap = $(html);
    const $ul = $wrap.find("ul").first().addClass("hidden");
    $ul.children("li").css({ opacity: 0 });
    return $ul;
}
